<template>
  <div class="input" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div>
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseControlError from "../Elements/BaseControlError";
import BaseControlDescription from "../Elements/BaseControlDescription";
import BaseLabel from "../Elements/BaseLabel";

export default {
  name: "BaseFormControl",
  components: {
    BaseControlError,
    BaseControlDescription,
    BaseLabel
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    labelDescription: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    number: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: ""
    },
    controlClass: {
      type: String,
      default: ""
    },
    descriptionClass: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      data: this.value,
      controlOptions: {
        labelClass: this.labelClass || "form__label",
        inlineLabelClass:
          this.labelClass || "col-form-label col-sm-7 form__label",
        controlClass: this.controlClass || "form__control",
        inlineControlClass: this.controlClass || "col-sm-5 form__control",
        descriptionClass: this.descriptionClass || "form__control-description",
        inlineDescriptionClass:
          this.descriptionClass ||
          "offset-sm-7 col-sm-5 form__control-description",
        wrapperClass:
          this.wrapperClass || "form__group form__group--horizontal",
        inlineWrapperClass:
          this.wrapperClass || "row form__group form__group--inline"
      }
    };
  },
  computed: {
    ...mapGetters("Form", ["getError"]),
    error() {
      let e = this.getError(`form.${this.$parent.name}`);
      return e || "";
    },
    hasError() {
      return !!this.error;
    },
    labelClasses() {
      return {
        [this.controlOptions.labelClass]: !this.inline,
        [this.controlOptions.inlineLabelClass]: this.inline
      };
    },
    controlClasses() {
      return {
        [this.controlOptions.controlClass]: !this.inline,
        [this.controlOptions.inlineControlClass]: this.inline
      };
    },
    descriptionClasses() {
      return {
        [this.controlOptions.descriptionClass]: !this.inline,
        [this.controlOptions.inlineDescriptionClass]: this.inline
      };
    },
    wrapperClasses() {
      return {
        [this.controlOptions.wrapperClass]: !this.inline,
        [this.controlOptions.inlineWrapperClass]: this.inline,
        "form__group--no-number": !this.number
      };
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.data = newValue;
      }
    }
  },
  methods: {
    emitEvent(event) {
      this.$emit("input", event);
    },
    vTouch() {
      this.v && this.$touch();
    },
    touch(validator) {
      validator && validator.$touch && validator.$touch();
    }
  }
};
</script>

<style lang="scss">
.form-group {
  // background: #e0e0e0;
  // &:hover {
  //   background: red;
  // }
}
.form__label {
  padding-top: calc(0.375rem + 7px);
  padding-bottom: calc(0.375rem + 1px);
  padding-left: 30px;
  position: relative;
}
.form__control-description {
  padding-left: 30px;
  padding-bottom: calc(0.375rem + 1px);
}
.form__control {
  padding-left: 30px;
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
}
.form__label-number {
  left: 0;
  position: absolute;
  font-weight: bold;
  width: 30px;
  &:after {
    content: ".";
  }
}

.form__label-description {
  font-size: 0.8em;
  display: block;
  &:before {
    content: "(";
  }
  &:after {
    content: ")";
  }
}

.form__group--horizontal {
  .form__label {
    padding-bottom: 0;
  }
  .form__control {
    padding-top: 0;
  }
}

[class*="col-"] {
  &.form__label {
    padding-left: 50px;
  }
  &.form__label .form__label-number {
    left: 15px;
  }
  &.form__control-description,
  &.form__control {
    padding-left: 50px;
  }
}

.form__group--inline {
  .form__control-description,
  .form__control {
    padding-left: 15px;
    @media (max-width: 400px) {
      padding-left: 48px;
    }
  }
}

.form__group--no-number {
  &.form__group--horizontal {
    .form__control-description,
    .form__control,
    .form__label {
      padding-left: 0;
    }
  }
  &.form__group--inline {
    .form__label {
      padding-left: 15px;
    }
  }
}

.modal-dialog .form__group--horizontal .form__label {
  padding-top: 0;
}
</style>
